import { render, staticRenderFns } from "./inOrdP.vue?vue&type=template&id=b5dcb91c&scoped=true"
import script from "./inOrdP.vue?vue&type=script&lang=js"
export * from "./inOrdP.vue?vue&type=script&lang=js"
import style0 from "./inOrdP.vue?vue&type=style&index=0&id=b5dcb91c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5dcb91c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5dcb91c')) {
      api.createRecord('b5dcb91c', component.options)
    } else {
      api.reload('b5dcb91c', component.options)
    }
    module.hot.accept("./inOrdP.vue?vue&type=template&id=b5dcb91c&scoped=true", function () {
      api.rerender('b5dcb91c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/inventory/inOrdP.vue"
export default component.exports